// src/app/core/loading/loader.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private _counter = 0;
  private _visible$ = new BehaviorSubject<boolean>(false);
  readonly visible$ = this._visible$.asObservable();

  private showTimer?: any;  // evita parpadeos (muestra tras pequeño delay)
  private hideTimer?: any;  // evita parpadeos (oculta tras pequeño delay)

  private readonly SHOW_DELAY = 150; // ms
  private readonly HIDE_DELAY = 150; // ms

  show(): void {
    this._counter++;
    if (this.hideTimer) { clearTimeout(this.hideTimer); this.hideTimer = null; }
    if (!this.showTimer && !this._visible$.value) {
      this.showTimer = setTimeout(() => {
        this._visible$.next(true);
        this.showTimer = null;
      }, this.SHOW_DELAY);
    }
  }

  hide(): void {
    this._counter = Math.max(0, this._counter - 1);
    if (this._counter === 0) {
      if (this.showTimer) { clearTimeout(this.showTimer); this.showTimer = null; }
      if (!this.hideTimer && this._visible$.value) {
        this.hideTimer = setTimeout(() => {
          this._visible$.next(false);
          this.hideTimer = null;
        }, this.HIDE_DELAY);
      }
    }
  }

  /** Para navegación: fuerza estado sin tocar el contador */
  setVisible(force: boolean) {
    if (force) this._visible$.next(true);
    else if (this._counter === 0) this._visible$.next(false);
  }
}
